import { html, nothing } from "lit";
import { ActivityHistoryFullDataError } from "./component";
import { translate } from "../../../../localization";
export const template = (props: ActivityHistoryFullDataError) => {
  return html`
    ${props.isAllDataFailedToLoad ? renderErrorFeedback(props) : nothing}
  `;
};

const renderErrorFeedback = (props: ActivityHistoryFullDataError) => {
  return html`
    <div class="container">
      <dss-user-feedback status="error" variant="default" size="lg" title=${translate("error.title")} description=${translate("error.general.title")} hasdetails="" detailslabel=${translate("error.viewDetails")}>
        <div slot="details">
          ${props.errorMessages.length > 0 ? html`<div>${props.errorMessages.map((error) => html`<div>${error.message}</div>`)}</div>` : translate("error.general.noInfo")}
        </div>
        <dss-button @onClick=${props.handleClickFeedback} label=${translate("error.general.refresh")} size="lg"></dss-button>
      </dss-user-feedback>
    </div>
  `;
};
